///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import { isArray } from 'lodash'
import ActionsTypes from '../../constants/ActionsTypes'
import { globalLoadingActionCreators, errorManagerActionCreators, toastSuccessActionCreators, campaignPriceActionCreators } from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'

const getCampaign = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_CAMPAIGN(payload.idCampaign)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(campaignPriceActionCreators.getCampaignSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(campaignPriceActionCreators.getCampaignFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const updateCampaign = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.UPDATE_CAMPAIGN(payload.idCampaign)
	const dataFormat = payload.data

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, dataFormat)

		yield put(campaignPriceActionCreators.updateCampaignSuccess(data.data, payload.idCampaign))

		yield put(toastSuccessActionCreators.hydrateToast('toast__pricesManagement__pricesCampaign_update_message'))
	} catch (e) {
		if (!isArray(e.response?.data)) {
			yield put(errorManagerActionCreators.createError(e.response))
		} // guard to layout modal error on managed error

		yield put(campaignPriceActionCreators.updateCampaignFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const cancelCampaign = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.CANCEL_CAMPAIGN(payload.idCampaign)
	const dataFormat = payload.data

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, dataFormat)

		yield put(campaignPriceActionCreators.cancelCampaignSuccess(data.data, payload.idCampaign))

		yield put(toastSuccessActionCreators.hydrateToast('toast__pricesManagement__pricesCampaign_cancelation_message'))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(campaignPriceActionCreators.cancelCampaignFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const createCampaign = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.CREATE_CAMPAIGN(payload.action)
	const dataFormat = payload.campaign

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, dataFormat)

		yield put(campaignPriceActionCreators.createCampaignSuccess(data.data, payload.idCampaign))
		yield put(campaignPriceActionCreators.resetCampaign())

		yield put(toastSuccessActionCreators.hydrateToast('toast__pricesManagement__pricesCampaign_validation_message'))
	} catch (e) {
		if (e.response?.status !== 400) {
			yield put(errorManagerActionCreators.createError(e.response))
		} else {
			yield put(campaignPriceActionCreators.createCampaignFailure(e.response))
		} // guard to layout modal error on managed error
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const checkCampaign = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.CHECK_ITEMS_CAMPAIGN(payload.target)

	const dataFormat = payload.campaign

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, dataFormat)

		yield put(campaignPriceActionCreators.checkCampaignSuccess(data.data, payload.idCampaign))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(campaignPriceActionCreators.checkCampaignFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.GET_CAMPAIGN, getCampaign)
	yield takeLatest(ActionsTypes.UPDATE_CAMPAIGN, updateCampaign)
	yield takeLatest(ActionsTypes.CANCEL_CAMPAIGN, cancelCampaign)
	yield takeLatest(ActionsTypes.POST_CHECK_CAMPAIGN, checkCampaign)
	yield takeLatest(ActionsTypes.CREATE_CAMPAIGN, createCampaign)
}

export default sagas
